import { headers, parseJSON } from '../../apiUtils';
import { arrayIsNotEmpty } from '../../utils';

export function fetchTeamsJibeStats() {
    let path = `/api/Jibe/teams-jibe-stats`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchTeamsJibedPercentageStats() {
    let path = `/api/Jibe/teams-Jibed-percentage-jibe-stats`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchTeamAgentsJibeStats(teamId) {
    let path = `/api/Jibe/team-agents-jibe-stats?teamId=${teamId}`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchJibeProgressOverTimeStats(fromDate, toDate, timePeriodicity, selectedFilters) {
    let path = `/api/Jibe/jibe-progress-over-time-stats?fromDate=${fromDate}&toDate=${toDate}&timePeriodicity=${timePeriodicity}`;
    if (arrayIsNotEmpty(selectedFilters)) {
        const newArray = selectedFilters.map(obj => {
            return {
                domainValueId: obj.id,
                domainValueName: obj.value,
                domainId: obj.domainId
            };
        });

        const stringifySelectedFilters = JSON.stringify(newArray);
        path += `&selectedFilters=${stringifySelectedFilters}`;
    }

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchJibeProgressOverTimeBreakdownStats(pageBreakdown, fromDate, toDate, timePeriodicity, selectedFilters, teamId) {
    let path = `/api/Jibe/jibe-progress-over-time-stats?fromDate=${fromDate}&toDate=${toDate}&timePeriodicity=${timePeriodicity}`;
    if (arrayIsNotEmpty(selectedFilters)) {
        const newArray = selectedFilters.map(obj => {
            return {
                domainValueId: obj.id,
                domainValueName: obj.value,
                domainId: obj.domainId
            };
        });

        const stringifySelectedFilters = JSON.stringify(newArray);
        path += `&selectedFilters=${stringifySelectedFilters}`;
    }
    if (pageBreakdown) {
        path += `&breakdown=${pageBreakdown}`;
    }
    if (teamId) {
        path += `&teamId=${teamId}`;
    }
    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}
export function fetchJibeSessionsOverTimeStats(fromDate, toDate, timePeriodicity, teamId) {
    //const toDateUtc = getUtcTime(toDate);
    //const fromDateUtc = getUtcTime(fromDate);
    let path = `/api/Jibe/jibe-sessions-over-time-stats?fromDate=${fromDate}&toDate=${toDate}&timePeriodicity=${timePeriodicity}`;
    if (teamId) {
        path += `&teamId=${teamId}`;
    }
    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchAgentJibeSummary(userId) {
    const path = `/api/Jibe/agent-jibe-summary?userId=${userId}`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchAgentJibeProgressOverTimeStats(userId, fromDate, toDate) {
    const path = `/api/Jibe/agent-jibe-progress-over-time-stats?userId=${userId}&fromDate=${fromDate}&toDate=${toDate}`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchAgentInteractions(userId, fromDate, toDate) {
    //const toDateUtc = getUtcTime(toDate);
    //const fromDateUtc = getUtcTime(fromDate);
    const path = `/api/Jibe/agent-interactions?userId=${userId}&fromDate=${fromDate}&toDate=${toDate}`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function _postJibeSession(jibeSession) {
    const url = `/api/Jibe/agent-jibe-session`;
    return fetch(url, {
        headers: headers(),
        body: JSON.stringify(jibeSession),
        method: 'POST'
    });
}